import { fullscreenLoader } from '@core/components/Loader/Page/PageLoader';
import { commonConfig } from '@core/config';
import { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const External = (): ReactElement | null => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search || window.location.search);
    if (window.opener) {
      window.opener?.postMessage(
        {
          app: commonConfig.company.name,
          data: Object.fromEntries(params.entries()),
        },
        window.opener.document.location.href,
      );
      window.close();
      return;
    }
  }, [location.search]);

  return fullscreenLoader;
};
export default External;
